<template>
    <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="h-4 w-4"><path d="M432 256l-192 192-192-192 19-19 173 173 173-173 19 19z"/></svg>
</template>
<style lang="sass" scoped>
svg
    fill: #000
</style>